import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '@/layout/Main';

Vue.use(VueRouter);
const titulo = 'Vessi - Somos el primer gran paso para modernizar tu negocio';

const routes = [
	{
		path: '/renovar/:token',
		component: Main,
		name: 'renovar',
		children: [
			{
				path: '/',
				component: () => import('@/views/Renovacion'),
				meta: {
					title: titulo,
				},
			},
		]
	},
	{
		path: '/resultado-pago/:estado/:idorden',
		component: Main,
		name: 'resulado-pago',
		children: [
			{
				path: '/',
				component: () => import('@/views/ResultadoPago'),
				meta: {
					title: titulo,
				},
			},
		]
	},
	{
		path: '/venta-asistida/:vendedorasistente',
		component: Main,
		name: 'venta-asistida',
		children: [
			{
				path: '/',
				component: () => import('@/views/Contratacion'),
				meta: {
					title: titulo,
				},
			},
		]
	},
	{
		path: '/:vendedor?',
		component: Main,
		name: 'contratar',
		children: [
			{
				path: '/',
				component: () => import('@/views/Contratacion'),
				meta: {
					title: titulo,
				},
			},
		]
	},
	{
		path: '/contratacion-prellenada/:tokenprellenado',
		component: Main,
		name: 'contratar',
		children: [
			{
				path: '/',
				component: () => import('@/views/Contratacion'),
				meta: {
					title: titulo,
				},
			},
		]
	},
	// Si no calzó ruta con las anteriores, informar 404
	{
		path: '*',
		component: Main,
		name: 'no-encontrado',
		children: [
			{
				path: '/',
				component: () => import('@/views/NoEncontrado'),
				meta: {
					title: 'Página no encontrada',
				},
			},
		],
	}
];

const routerConfig = {
	mode: 'history',
	base: process.env.BASE_URL,
	routes
};

const router = new VueRouter(routerConfig);

router.afterEach((to, from) => {
	// Set route title in navigator
	Vue.nextTick(() => {
		document.title = to.meta.title;
	});
});

export default router;
